// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hDS8","content":"styles_content__F8pRE"};